import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
        ...state
    }
}

const LoadingComponent = (props) => {
    console.log(props);
    const { showModal } = props.LoadingReducer;
    console.log(showModal);
    const style = {
        display: showModal ? 'block' : 'none'
        //display: 'block'
    };

    const overlayStyle = {
        ...style,
        position: 'fixed',
        height: '100%',
        width: '100%',
        background: 'rgba(2, 2, 2, 0.64)',
        top: '0em',
        left: 0,
        zIndex: 50
    }
    //LoadingReducer.showModal
    return (
        <div style={overlayStyle} className="overlay">
            <div className="modal" style={overlayStyle} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="loading-message">
                                <p>Please wait...</p>
                                <div className="loading-icon">
                                    <div className="fa fa-spinner">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(mapStateToProps)(LoadingComponent);


// WEBPACK FOOTER //
// ./src/LoadingComponent/index.js